var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.737 3c1.494 0 2.745.52 3.752 1.56C21.496 5.6 22 6.893 22 8.436c0 1.958-.746 3.795-2.237 5.51a68.264 68.264 0 01-4.988 5.134l-1.496 1.402c-.172.179-.374.31-.605.394a2 2 0 01-.684.125c-.225 0-.452-.041-.68-.125a1.594 1.594 0 01-.6-.394l-1.512-1.419A70.537 70.537 0 014.2 13.884C2.733 12.188 2 10.372 2 8.434c0-1.542.504-2.833 1.51-3.873C4.519 3.52 5.77 3 7.264 3c.848 0 1.687.202 2.515.606.828.405 1.569 1.06 2.222 1.97.653-.91 1.394-1.565 2.222-1.97C15.05 3.202 15.889 3 16.737 3zM12.25 9.114c-.145-.152-.347-.152-.5 0-.153.153-1.516 1.583-1.516 1.583l-.023.026c-.243.263-.71.77-.711 1.41 0 .789.563 1.445 1.375 1.445.197 0 .372-.033.528-.092l-.287 1.206a.25.25 0 00.243.308h1.285a.25.25 0 00.243-.308l-.29-1.218c.17.067.35.104.528.104.813 0 1.375-.656 1.375-1.444 0-.657-.492-1.18-.75-1.444l-1.5-1.576z",
    fill: "currentColor"
  })));
}
SvgLoyaltyFilled.displayName = 'LoyaltyFilled';
export default SvgLoyaltyFilled;